{
  "identities.messages.1010001": "Hyɛn mu",
  "identities.messages.1010002": "Hyɛn mu fa {provider}",
  "identities.messages.1010003": "Yɛsrɛ wo si so dua dwumadi yi denam wo ho hwehwɛmu so sɛ ɛyɛ wo.",
  "identities.messages.1010004": "Yɛsrɛ wo wie nhwehwɛmu a ɛto so abien no.",
  "identities.messages.1010005": "Hwehwɛ mu",
  "identities.messages.1010006": "Nhwehwɛmu koodu",
  "identities.messages.1010007": "Nsaneɛ-siesie kɔd",
  "identities.messages.1010008": "Kɔ so fa hadwɛɛ safoa",
  "identities.messages.1010009": "Kɔ so",
  "identities.messages.1010010": "Kɔ so",
  "identities.messages.1010011": "Hyɛn mu fa hadwɛɛ safoa",
  "identities.messages.1010012": "Siesie wo WebAuthn mfiri (te sɛ ahobammɔ safoa, biometrics hwehwɛso, ...) na mia kɔ so.",
  "identities.messages.1010013": "Kɔ so",
  "identities.messages.1010014": "Wɔde koodu bi akɔma adresee a wode mae no. Sɛ woannya a, yɛsrɛ wo hwehwɛ adresee no nhyerɛw mu na san yɛ bio.",
  "identities.messages.1010015": "Soma hyɛnmu koodu",
  "identities.messages.1010016": "Wubɔɔ mmɔden sɛ wobɛhyɛn mu fa \"{duplicateIdentifier}\", nanso saa email no wɔde redi dwuma dedaw wɔ akɔnt foforo bi mu. Hyɛn mu fa wo akɔnt mu denam nhyehyɛe a ɛwɔ ase ha yi so sɛnea ɛbɛyɛ a wobɛka wo akɔnt \"{duplicateIdentifier}\" a ɛwɔ \"{provider}\" ho sɛ ɔkwan foforo a wɔfa so hyɛn mu.",
  "identities.messages.1010017": "Hyɛn mu na fa bata ho",
  "identities.messages.1010018": "Si so dua fa {provider}",
  "identities.messages.1010019": "Bisa koodu sɛnea ɛbɛyɛ a wobɛkɔ so",
  "identities.messages.1010021": "Hyɛn mu fa paseki",
  "identities.messages.1010022": "Hyɛn mu fa asɛmfua",
  "identities.messages.1010023": "Soma koodu kɔ {address}",
  "identities.messages.1040001": "Kyerɛw wo din",
  "identities.messages.1040002": "Kyerɛw wo din fa {provider}",
  "identities.messages.1040003": "Kɔ so",
  "identities.messages.1040004": "Kyerɛw wo din fa ahobammɔ safoa",
  "identities.messages.1040005": "Wɔde koodu bi akɔma adresee(s) a wode mae no. Sɛ woannya nkrasɛm a, hwehwɛ adresee no nhyerɛw mu na san yɛ nhyehyɛe no bio.",
  "identities.messages.1040006": "Soma nhyehyɛe koodu",
  "identities.messages.1040007": "Kyerɛw wo din fa paseki",
  "identities.messages.1040008": "San kɔ",
  "identities.messages.1040009": "Yɛsrɛ wo yi nneɛma a wode bɛhwehwɛ wo ho mu no.",
  "identities.messages.1050001": "Wɔakora wo nsakrae no!",
  "identities.messages.1050002": "Fa {provider} bata ho",
  "identities.messages.1050003": "Yi {provider} fi ho",
  "identities.messages.1050004": "Yi TOTP Nhwehwɛmu Aplikehyɛn no fi ho",
  "identities.messages.1050005": "Nhwehwɛmu aplikehyɛn QR koodu",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Da nneɛma a wɔde sie nsan kɔ koodu adi",
  "identities.messages.1050008": "Ma kwan",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Eyi ne wo nneɛma a wɔde sie nsan kɔ koodu. Yɛsrɛ wo sie wɔn wɔ baabi a ahobammɔ wɔ!",
  "identities.messages.1050011": "Si nneɛma a wɔde sie nsan kɔ koodu so dua",
  "identities.messages.1050012": "Ka ahobammɔ safoa ho",
  "identities.messages.1050013": "Ahobammɔ safoa no din",
  "identities.messages.1050014": "Wɔde sum no dii dwuma wɔ {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Twa saa ɔkwan yi",
  "identities.messages.1050017": "Nhwehwɛmu ahintasɛm",
  "identities.messages.1050018": "Yi ahobammɔ safoa \"{display_name}\" fi ho",
  "identities.messages.1050019": "Ka paseki ho",
  "identities.messages.1050020": "Yi paseki \"{display_name}\" fi ho",
  "identities.messages.1060001": "Woasan gyee wo akɔnt no yie. Yɛsrɛ wo sesa wo asɛmfua anaasɛ hyehyɛ ɔkwan foforo a wɔfa so hyɛn mu (te sɛ asetra so hyɛnmu) wɔ simma {privileged_session_expires_at_unix_until_minutes} a ɛbɛba no mu.",
  "identities.messages.1060002": "Wɔde email a nsan kɔ lɛnke wom akɔma email adresee a wode mae no. Sɛ woannya email a, hwehwɛ adresee no nhyerɛw mu na hwɛ sɛ wode adresee a wode kyerɛw wo din no redi dwuma.",
  "identities.messages.1060003": "Wɔde email a nsan kɔ koodu wom akɔma email adresee a wode mae no. Sɛ woannya email a, hwehwɛ adresee no nhyerɛw mu na hwɛ sɛ wode adresee a wode kyerɛw wo din no redi dwuma.",
  "identities.messages.1060004": "Wɔde nsan kɔ koodu akɔma \"{masked_address}\". Sɛ woannya a, hwehwɛ adresee no nhyerɛw mu na hwɛ sɛ wode adresee a wode kyerɛw wo din no redi dwuma.",
  "identities.messages.1060005": "San kɔ wo akɔnt no so denam wo nsan kɔ adresee a wode bɛma no nyinaa so.",
  "identities.messages.1060006": "Ɔkwan bɛn so na wopɛ sɛ wosan kɔ wo akɔnt no so?",
  "identities.messages.1060007": "San kɔ",
  "identities.messages.1070001": "Asɛmfua",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Sie",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "De kɔ",
  "identities.messages.1070006": "Hwehwɛ koodu mu",
  "identities.messages.1070007": "Email",
  "identities.messages.1070008": "San soma koodu",
  "identities.messages.1070009": "Kɔ so",
  "identities.messages.1070010": "Nsan kɔ koodu",
  "identities.messages.1070011": "Nhwehwɛmu koodu",
  "identities.messages.1070012": "Nhyehyɛe koodu",
  "identities.messages.1070013": "Hyɛnmu koodu",
  "identities.messages.1070014": "Hyɛn mu na fa nneɛma a wɔde hwehwɛ mu bata ho",
  "identities.messages.1070015": "Yɛsrɛ wo wie captcha asɔhwɛ no sɛnea ɛbɛyɛ a wobɛkɔ so.",
  "identities.messages.1070016": "Nsan kɔ adresee",
  "identities.messages.1070017": "Telefon nɔma",
  "identities.messages.1080001": "Wɔde email a nhwehwɛmu lɛnke wom akɔma email adresee a wode mae no. Sɛ woannya email a, hwehwɛ adresee no nhyerɛw mu na hwɛ sɛ wode adresee a wode kyerɛw wo din no redi dwuma.",
  "identities.messages.1080002": "Wohwehwɛɛ wo email adresee no mu yie.",
  "identities.messages.1080003": "Wɔde email a nhwehwɛmu koodu wom akɔma email adresee a wode mae no. Sɛ woannya email a, hwehwɛ adresee no nhyerɛw mu na hwɛ sɛ wode adresee a wode kyerɛw wo din no redi dwuma.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Yɛsrɛ wo hyɛ {property} no mu na san yɛ bio.",
  "identities.messages.4000003": "tenten ɛsɛ sɛ ɛyɛ >= {min_length}, nanso wunyaa {actual_length}",
  "identities.messages.4000004": "ɛnhyia nhyehyɛe \"{pattern}\" no",
  "identities.messages.4000005": "Wɔrentumi mfa asɛmfua no nni dwuma efisɛ {reason}.",
  "identities.messages.4000006": "Nneɛma a wode mae no nyɛ nokware, hwehwɛ mfomso a ɛwɔ wo asɛmfua anaasɛ wo din, email adresee, anaasɛ telefon nɔma no mu.",
  "identities.messages.4000007": "Akɔnt bi a ɛwɔ gyinahyɛde koro (email, telefon, din, ...) wɔ hɔ dedaw.",
  "identities.messages.4000008": "Nhwehwɛmu koodu a wode mae no nyɛ nokware, yɛsrɛ wo san yɛ bio.",
  "identities.messages.4000009": "Wɔanhu hyɛnmu gyinahyɛde biara. Wo werɛ fii sɛ wobɛhyehyɛ wɔn? Eyi nso betumi afi sɛva nhyehyɛe a ɛnyɛ yie hɔ.",
  "identities.messages.4000010": "Akɔnt no nnyɛ adwuma ɛ. Wo werɛ fii sɛ wobɛhwehwɛ wo email adresee no mu?",
  "identities.messages.4000011": "Wonni TOTP mfiri a wɔahyehyɛ.",
  "identities.messages.4000012": "Wɔde saa nneɛma a wɔde sie nsan kɔ koodu yi adi dwuma dedaw.",
  "identities.messages.4000013": "Wonni WebAuthn mfiri a wɔahyehyɛ.",
  "identities.messages.4000014": "Wonni nneɛma a wɔde sie nsan kɔ koodu a wɔahyehyɛ.",
  "identities.messages.4000015": "Saa akɔnt yi nni hɔ anaasɛ wonni ahobammɔ safoa a wɔahyehyɛ.",
  "identities.messages.4000016": "Nneɛma a wɔde sie nsan kɔ koodu no nyɛ nokware.",
  "identities.messages.4000017": "tenten ɛsɛ sɛ ɛyɛ <= {max_length}, nanso wunyaa {actual_length}",
  "identities.messages.4000018": "ɛsɛ sɛ ɛyɛ >= {minimum} nanso wohuu {actual}",
  "identities.messages.4000019": "ɛsɛ sɛ ɛyɛ > {minimum} nanso wohuu {actual}",
  "identities.messages.4000020": "ɛsɛ sɛ ɛyɛ <= {maximum} nanso wohuu {actual}",
  "identities.messages.4000021": "ɛsɛ sɛ ɛyɛ < {maximum} nanso wohuu {actual}",
  "identities.messages.4000022": "{actual} nyɛ {base} dodow pii",
  "identities.messages.4000023": "wɔma kwan ma nneɛma {max_items} pii, nanso wohuu nneɛma {actual_items}",
  "identities.messages.4000024": "wɔma kwan ma nneɛma {min_items} kakra, nanso wohuu nneɛma {actual_items}",
  "identities.messages.4000025": "nneɛma a ɛwɔ beae {index_a} ne {index_b} yɛ pɛ",
  "identities.messages.4000026": "na wɔrehwɛ {allowed_types_list}, nanso wunyaa {actual_type}",
  "identities.messages.4000027": "Akɔnt bi a ɛwɔ gyinahyɛde koro (email, telefon, din, ...) wɔ hɔ dedaw. Yɛsrɛ wo hyɛn mu fa wo akɔnt a ɛwɔ hɔ dedaw no mu sɛnea ɛbɛyɛ a wobɛfa wo asetra so kratafa bata ho.",
  "identities.messages.4000028": "Wubɔɔ mmɔden sɛ wobɛhyɛn mu fa {credential_identifier_hint} a akɔnt foforo de redi dwuma dedaw. Wubetumi ahyɛn mu denam {available_credential_types_list} so. Wubetumi ahyɛn mu denam asetra so hyɛnmu a edidi so yi mu biako so: {available_oidc_providers_list}.",
  "identities.messages.4000029": "ɛsɛ sɛ ɛne {expected} a ɛnsakra no yɛ pɛ",
  "identities.messages.4000030": "const no antumi anyɛ adwuma",
  "identities.messages.4000031": "Wɔrentumi mfa asɛmfua no nni dwuma efisɛ ɛte sɛ gyinahyɛde no pii.",
  "identities.messages.4000032": "Ɛsɛ sɛ asɛmfua no tenten yɛ nkyerɛwde {min_length} koraa, nanso wunyaa {actual_length}.",
  "identities.messages.4000033": "Ɛsɛ sɛ asɛmfua no tenten yɛ nkyerɛwde {max_length} pii, nanso wunyaa {actual_length}.",
  "identities.messages.4000034": "Wɔahu asɛmfua no wɔ nsɛm a wɔabubu mu na ɛnsɛ sɛ wɔde di dwuma bio.",
  "identities.messages.4000035": "Saa akɔnt yi nni hɔ anaasɛ wɔanhyehyɛ hyɛnmu a wɔde koodu di dwuma.",
  "identities.messages.4000036": "Nneɛma a wode mae no nne nneɛma a na ɛwɔ saa nhyehyɛe yi ho dedaw no.",
  "identities.messages.4000037": "Saa akɔnt yi nni hɔ anaasɛ wonni hyɛnmu ɔkwan a wɔahyehyɛ.",
  "identities.messages.4000038": "Captcha nhwehwɛmu no antumi anyɛ adwuma, yɛsrɛ wo san yɛ bio.",
  "identities.messages.4010001": "Nnwuma no ne ho ato. Fa wo ho bɛtumi san yɛ.",
  "identities.messages.4010002": "Wɔanhu ɔkwan a wɔfa so de wo hyɛn mu. Wɔhyɛɛ fɔɔm no mu yie?",
  "identities.messages.4010003": "Wɔanhu ɔkwan a wɔfa so kyerɛw wo din. Wɔhyɛɛ fɔɔm no mu yie?",
  "identities.messages.4010004": "Wɔanhu ɔkwan a wɔfa so ma wo nhyehyɛe no yɛ foforo. Wɔhyɛɛ fɔɔm no mu yie?",
  "identities.messages.4010005": "Wɔanhu ɔkwan a wɔfa so san gye wo akɔnt no. Wɔhyɛɛ fɔɔm no mu yie?",
  "identities.messages.4010006": "Wɔanhu ɔkwan a wɔfa so hwehwɛ wo akɔnt no mu. Wɔhyɛɛ fɔɔm no mu yie?",
  "identities.messages.4010007": "Wɔwie abisade no yie dedaw na wɔrentumi nsane nyɛ bio.",
  "identities.messages.4010008": "Hyɛnmu koodu no nyɛ nokware anaasɛ wɔde adi dwuma dedaw. Yɛsrɛ wo san yɛ bio.",
  "identities.messages.4010009": "Nneɛma a wɔde hwehwɛ mu a wɔde bata ho no nne.",
  "identities.messages.4010010": "Adresee a wode hyɛɛ mu no nne adresee biara a wonim wɔ akɔnt a ɛwɔ hɔ mprempren no mu.",
  "identities.messages.4040001": "Nnwuma no ne ho ato. Fa wo ho bɛtumi san yɛ.",
  "identities.messages.4040002": "Wɔwie abisade no yie dedaw na wɔrentumi nsane nyɛ bio.",
  "identities.messages.4040003": "Nhyehyɛe koodu no nyɛ nokware anaasɛ wɔde adi dwuma dedaw. Yɛsrɛ wo san yɛ bio.",
  "identities.messages.4050001": "Nnwuma no ne ho ato. Fa wo ho bɛtumi san yɛ.",
  "identities.messages.4060001": "Wɔwie abisade no yie dedaw na wɔrentumi nsane nyɛ bio.",
  "identities.messages.4060002": "Nsan kɔ nhyehyɛe no duu tebea a ɛnyɛ yie na ɛsɛ sɛ wɔsan yɛ bio.",
  "identities.messages.4060004": "Nsan kɔ gyinapɛn no nyɛ nokware anaasɛ wɔde adi dwuma dedaw. Yɛsrɛ wo san yɛ nhyehyɛe no bio.",
  "identities.messages.4060005": "Nnwuma no ne ho ato. Fa wo ho bɛtumi san yɛ.",
  "identities.messages.4060006": "Nsan kɔ koodu no nyɛ nokware anaasɛ wɔde adi dwuma dedaw. Yɛsrɛ wo san yɛ bio.",
  "identities.messages.4070001": "Nhwehwɛmu gyinapɛn no nyɛ nokware anaasɛ wɔde adi dwuma dedaw. Yɛsrɛ wo san yɛ nhyehyɛe no bio.",
  "identities.messages.4070002": "Wɔwie abisade no yie dedaw na wɔrentumi nsane nyɛ bio.",
  "identities.messages.4070003": "Nhwehwɛmu nhyehyɛe no duu tebea a ɛnyɛ yie na ɛsɛ sɛ wɔsan yɛ bio.",
  "identities.messages.4070005": "Nnwuma no ne ho ato. Fa wo ho bɛtumi san yɛ.",
  "identities.messages.4070006": "Nhwehwɛmu koodu no nyɛ nokware anaasɛ wɔde adi dwuma dedaw. Yɛsrɛ wo san yɛ bio.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "Fi adi",
  "login.registration-button": "Kyerɛw wo din",
  "login.registration-label": "Wonni akɔnt?",
  "login.title": "Hyɛn mu",
  "login.subtitle": "Hyɛn mu fa {parts}",
  "login.title-aal2": "Nhwehwɛmu a ɛto so abien",
  "login.subtitle-aal2": "Yi ɔkwan bi a wobɛfa so awie wo nhwehwɛmu a ɛto so abien no",
  "login.code.subtitle": "Wɔde nhwehwɛmu koodu bɛsoma denam email so",
  "login.webauthn.subtitle": "Yɛsrɛ wo siesie wo WebAuthn mfiri",
  "login.totp.subtitle": "Yɛsrɛ wo hyɛ koodu a wo Nhwehwɛmu Aplikehyɛn no yɛe no mu",
  "login.lookup_secret.subtitle": "Yɛsrɛ wo hyɛ wo nneɛma a wɔde sie nsan kɔ koodu a ɛyɛ nɔma 8 no mu biako",
  "login.title-refresh": "San hwehwɛ mu",
  "login.subtitle-refresh": "Si wo ho so dua fa {parts}",
  "login.2fa.go-back": "Biribi nyɛ adwuma?",
  "login.2fa.go-back.link": "San kɔ",
  "login.2fa.method.go-back": "Yi ɔkwan foforo",
  "recovery.title": "San gye wo akɔnt",
  "recovery.subtitle": "Hyɛ gyinahyɛde a ɛwɔ wo akɔnt no ho mu sɛnea ɛbɛyɛ a wubenya koodu a wɔde bedi dwuma prɛko pɛ",
  "registration.login-button": "Hyɛn mu",
  "registration.login-label": "Wowɔ akɔnt dedaw?",
  "registration.title": "Kyerɛw akɔnt bi din",
  "registration.subtitle": "Kyerɛw wo din fa {parts}",
  "settings.navigation-back-button": "San kɔ",
  "settings.subtitle": "Ma wo akɔnt nhyehyɛe no yɛ foforo",
  "settings.title": "Akɔnt Nhyehyɛe",
  "settings.password.title": "Sesa Asɛmfua",
  "settings.password.description": "Sesa wo asɛmfua",
  "settings.profile.title": "Kratafa Nhyehyɛe",
  "settings.profile.description": "Ma wo kratafa ho nsɛm yɛ foforo",
  "settings.webauthn.title": "Di Hadwɛɛ Gyinapɛn So",
  "settings.webauthn.description": "Di wo hadwɛɛ gyinapɛn nhyehyɛe so",
  "settings.messages.toast-title.success": "Wɔama nhyehyɛe no ayɛ foforo",
  "settings.messages.toast-title.error": "Wɔantumi amma nhyehyɛe no anyɛ foforo",
  "verification.title": "Hwehwɛ wo akɔnt mu",
  "verification.subtitle": "Hyɛ email adresee a ɛwɔ wo akɔnt no ho no mu sɛnea ɛbɛyɛ a wobɛhwehwɛ mu",
  "two-step.password.title": "Asɛmfua",
  "two-step.password.description": "Hyɛ wo asɛmfua a ɛwɔ wo akɔnt no ho no mu",
  "two-step.code.title": "Email koodu",
  "two-step.code.description": "Wɔde nhwehwɛmu koodu bɛsoma akɔ wo email",
  "two-step.webauthn.title": "Ahobammɔ safoa",
  "two-step.webauthn.description": "De wo ahobammɔ safoa di dwuma sɛnea wobɛhwehwɛ mu",
  "two-step.passkey.title": "Paseki (wɔkamfo)",
  "two-step.passkey.description": "De wo mfiri nsateaa anaasɛ anim ho nhumu di dwuma",
  "two-step.passkey.description.error": "Wɔantumi annya nneɛma a ɛho hia sɛ wode wo Paseki bedi dwuma. Yɛsrɛ wo san yɛ bio daakye.",
  "two-step.totp.title": "De wo Nhwehwɛmu Aplikehyɛn (TOTP) di dwuma",
  "two-step.totp.description": "De koodu a ɛyɛ nɔma 6 a wɔde di dwuma prɛko pɛ fi wo nhwehwɛmu aplikehyɛn no di dwuma",
  "two-step.lookup_secret.title": "Nneɛma a wɔde sie nsan kɔ koodu",
  "two-step.lookup_secret.description": "De wo nneɛma a wɔde sie koodu a ɛyɛ nɔma 8 no mu biako di dwuma sɛnea wobɛhwehwɛ mu",
  "input.placeholder": "Hyɛ wo {placeholder} mu",
  "card.header.parts.oidc": "asetra so ɔdefo",
  "card.header.parts.password.registration": "wo {identifierLabel} ne asɛmfua",
  "card.header.parts.password.login": "wo {identifierLabel} ne asɛmfua",
  "card.header.parts.code": "koodu a wɔde di dwuma prɛko pɛ",
  "card.header.parts.passkey": "Paseki",
  "card.header.parts.webauthn": "ahobammɔ safoa",
  "card.header.parts.totp": "wo nhwehwɛmu aplikehyɛn",
  "card.header.parts.lookup_secret": "nneɛma a wɔde sie nsan kɔ koodu",
  "card.header.parts.identifier-first": "wo {identifierLabel}",
  "misc.or": "anaasɛ",
  "forms.label.forgot-password": "Wo Werɛ Fii Asɛmfua?",
  "forms.label.recover-account": "San Gye Akɔnt",
  "settings.totp.title": "Nhwehwɛmu Aplikehyɛn",
  "settings.totp.description": "Ka TOTP Nhwehwɛmu Aplikehyɛn ho ma wo akɔnt sɛnea ɛbɛyɛ a wo akɔnt ahobammɔ bɛkɔ soro. Nhwehwɛmu Aplikehyɛn a wɔnim yie ne LastPass ne Google Authenticator",
  "settings.totp.info.not-linked": "Sɛnea ɛbɛyɛ a wubɛma kwan no, hwehwɛ QR koodu no fa wo nhwehwɛmu mu na hyɛ koodu no mu.",
  "settings.totp.info.linked": "Wowɔ nhwehwɛmu aplikehyɛn a wɔde abata ho mprempren.",
  "settings.lookup_secret.title": "Nneɛma a Wɔde Sie Nsan Kɔ Koodu (nea ɛto so abien)",
  "settings.lookup_secret.description": "Nsan kɔ koodu yɛ nneɛma a wɔde sie a ahobammɔ wɔ ma 2FA, na ɛma wo kwan ma wo san kɔ wo akɔnt so sɛ wohwere wo 2FA mfiri a.",
  "settings.oidc.title": "Akɔnt a wɔde abata ho",
  "settings.oidc.description": "Fa asetra so hyɛnmu ɔdefo bata wo akɔnt ho.",
  "settings.oidc.info": "Akɔnt a wɔde abata ho fi saa nnipa a wɔde ma yi hɔ no betumi de ahyɛn mu wɔ wo akɔnt no mu",
  "settings.webauthn.info": "Wɔde Hadwɛɛ Gyinapɛn di dwuma ma nhwehwɛmu a ɛto so abien anaasɛ sɛ nea ɛdi kan wɔ Paseki mu",
  "settings.passkey.title": "Di Paseki So",
  "settings.passkey.description": "Di wo paseki nhyehyɛe so",
  "settings.passkey.info": "Di wo paseki nhyehyɛe so",
  "card.footer.select-another-method": "Yi ɔkwan foforo",
  "account-linking.title": "Fa akɔnt bata ho",
  "property.password": "asɛmfua",
  "property.email": "email",
  "property.phone": "telefon",
  "property.username": "din",
  "property.identifier": "gyinahyɛde",
  "property.code": "koodu",
  "property.recovery_address": "nsan kɔ adresee",
  "consent.title": "Ma {party} tumi",
  "consent.subtitle": "Aplikehyɛn a ɛto so abiɛsa bi pɛ sɛ ɛkɔ nsɛm a ɛwɔ wo akɔnt {identifier} ho no so.",
  "consent.scope.openid.title": "Gyinahyɛde",
  "consent.scope.openid.description": "Ɛma aplikehyɛn no kwan ma ɛhwehwɛ wo ho mu. Eyi ho hia ma nhwehwɛmu ne hyɛnmu a wogye di.",
  "consent.scope.offline_access.title": "Kwan a Wonhyɛn Mu",
  "consent.scope.offline_access.description": "Ɛma saa aplikehyɛn yi kwan ma wo da so hyɛn mu mpo sɛ wonde redi dwuma ankasa a.",
  "consent.scope.profile.title": "Kratafa Ho Nsɛm",
  "consent.scope.profile.description": "Ɛma kwan ma wɔkɔ wo kratafa ho nsɛm titiriw so, a wo din, wo din a edi kan, ne wo din a etwa to ka ho.",
  "consent.scope.email.title": "Email Adresee",
  "consent.scope.email.description": "Nya wo email adresee ne ne nhwehwɛmu tebea.",
  "consent.scope.address.title": "Honam Adresee",
  "consent.scope.address.description": "Kɔ wo nkrataa adresee so.",
  "consent.scope.phone.title": "Telefon Nɔma",
  "consent.scope.phone.description": "Nya wo telefon nɔma ne ne nhwehwɛmu tebea.",
  "error.title.what-happened": "Dɛn na esii?",
  "error.title.what-can-i-do": "Dɛn na metumi ayɛ?",
  "error.instructions": "Yɛsrɛ wo san yɛ bio wɔ simma kakra mu anaasɛ di nkitaho wɔ wɛbsaet no dwumayɛfo so.",
  "error.footer.text": "Sɛ worebɔ saa mfomso yi ho amanneɛ a, yɛsrɛ wo fa nsɛm a edidi so yi ka ho:",
  "error.footer.copy": "Fa ko",
  "error.action.go-back": "San kɔ",
  "identities.messages.4000039": "Ahyɛnsode foforo no ɛnsɛ sɛ ɔne dadaa no yɛ pɛ.",
  "identities.messages.4000040": "Wɔ email adrɛɛs a ɛfata",
  "identities.messages.4000041": "Wɔ telefon nɔma a ɛfata",
  "captcha.error": "Bammɔ ho nhwehwɛmu no antumi anyɛ yie. Yɛsrɛ wo, bɔ mmɔden bio akyire yi. Sɛ ɔhaw no kɔ so a, di nkitaho fa mmoa ho.",
  "identities.messages.5000002": "Nnyansuo a wɔfa so de yɛ adwuma no, ɛwɔ hɔ. Ma nhwɛsofoɔ no a na wɔhwɛ saa nhyehyɛe no.",
  "identities.messages.4010011": "Sika a wɔde di dwuma no, wɔayɛ no ntam. Fa wo ho kyerɛɛ wɔn a wɔboa wɔn a wɔbɛboa wo.",
  "identities.messages.1070018": "Ɛda nsua a na ɛyɛ ne nnommmerɛ.",
  "identities.messages.1080004": "Wo deɛ na ɛfa wo ho no, ɛyɛɛ sɛ wɔayɛɛ wo animuonyam sɛdeɛ a ɛfa wo ho no. Sɛ worenya animuonyam no, hwehwɛ nkyerɛaseɛ a ɛwɔ nkyerɛaseɛ no mu na wiee sɛ wobɛfa nkyerɛaseɛ a worebɛyɛ no.",
  "identities.messages.1080005": "Woayɛ anigyeɛ na woayɛbea nkratoɔ no.",
  "identities.messages.5000003": "N'asɛmdeɛ bɛhia SSO nneɛma a wɔde si wɔ mu, nanso ɛnni sɛ wɔayɛ SSO nneɛma no. Maakyɛ wɔn a wɔhyehyɛ sistem no.",
  "identities.messages.1010024": "Wɔhwɛ a, de hardware key no sii.",
  "identities.messages.1010025": "Wɔde nkyerɛwde no akɔma w'akwantuo. Sɛ wo nsa nkaaeɛ a, mesrɛ wo, sɔ hwɛ bio.",
  "identities.messages.4000042": "Wo nni DeviceAuthn nkyɛnɛ a ɛyɛɛ.",
  "identities.messages.4000043": "Wɔde ama wo no, na ɛnyɛ den. Fa wo ho bɛhyia bio.",
  "identities.messages.4000044": "Ɛde biara, sɛnɛchɔ a ɛwɔ mu no nni hwee.",
  "identities.messages.4050002": "Ɛsɛ sɛ wɔde akwanya koro no ara na wɔbɛhunu. Mfa wo ho mmoa na wɔhunu akwanya koro biara."
}
